/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { QueryClient } from 'react-query';
import { useDeleteAllTagsMutation } from 'src/graphql';
import { TRootState } from 'src/store';

type CreateTagArgs = {
  tagType: string;
  mutationDeleteAllTags: ReturnType<
    typeof useDeleteAllTagsMutation
  >['mutateAsync'];
  queryClient: QueryClient;
};

export const deleteAllTagsAction = createAsyncThunk<
  void,
  CreateTagArgs,
  { state: TRootState }
>(
  'tagType/allTagsDeleted',

  async ({ tagType, mutationDeleteAllTags, queryClient }: CreateTagArgs) => {
    if (!tagType) return;

    await mutationDeleteAllTags({
      tagType,
    });

    queryClient.invalidateQueries('getOrganisationTagTypes');
  },
);
